const ErrorMessages = {
  required: (value: string) => `${value} is required`,
  selectOne: (value: string) => `You have to select at least one ${value}`,
  invalidEmail: `Invalid Email Address`,
  invalidURL: `Invalid URL`,
  passwordMismatch: `Passwords do not match`,
  invalidType: (value: string) => `Please input only ${value}`,
  length: (label: string, num = 6) =>
    `Your ${label} must be ${num} characters.`,
  maxLength: (label: string, num = 50) =>
    `Your ${label} must be less than ${num} characters.`,
  minLength: (label: string, num = 2) =>
    `Your ${label} must be more than ${num} characters.`,
  invalidTime: "Please enter a valid time",
  invalidPhoneNumber: "Please enter a valid phone number",
  requiredFieldsForOptions: "Please provide required fields for selected options",
  invalidFormat: (field: string) => `Please enter a valid ${field} format`,
};
export default ErrorMessages;
